import { render } from "./StockChart.vue?vue&type=template&id=133b9b6e"
import script from "./StockChart.vue?vue&type=script&lang=js"
export * from "./StockChart.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__